import React, { useEffect, useRef } from 'react';
import { getCsrfToken } from './csrf';

function Login() {
  const usernameRef = useRef(null);
  const failed = new URLSearchParams(window.location.search).get('error') !== null;

  useEffect(() => {
    usernameRef.current?.focus();
  }, []);

  return (
    <div className="container">
      <div className="top-bar">
        <span className="top-link-static">Log In</span>
      </div>

      <div className="account-box">
        <img src="/images/puppy.svg" alt="A cute puppy" className="puppy-img" />

        {failed && (
          <div className="account-errors">
            <p>Login failed.</p>
          </div>
        )}

        {/*
          A real form POST, not fetch/AJAX: Spring Security's formLogin() handles POST /login
          itself (there's no REST endpoint to call), and a full-page navigation on success is what
          re-arms the CSRF cookie for the first post-login mutation - see the CSRF gotcha note in
          CLAUDE.md.
        */}
        <form action="/login" method="POST" className="account-form">
          <input type="hidden" name="_csrf" value={getCsrfToken()} />

          <label htmlFor="username">Username</label>
          <input id="username" name="username" type="text" ref={usernameRef} required />

          <label htmlFor="password">Password</label>
          <input id="password" name="password" type="password" required />

          <button type="submit">Log In</button>
        </form>

        <p className="account-hint">
          Don't have an account yet? <a href="/createAccount">Create one</a>.
        </p>
      </div>
    </div>
  );
}

export default Login;
